




import {Component, Vue, Prop} from 'vue-property-decorator';
import Chart from 'chart.js';

@Component({})

export default class GroupingChart extends Vue {
    @Prop({ default: [] }) public labels!: any[];
    @Prop({ default: [] }) public colors!: any[];
    @Prop({ default: [] }) public data!: any[];
    @Prop() public id: string;

    public options: object | undefined = {
        legend: {
            position: 'right',
            align: 'center',
            display: true,
            rtl: false,
            labels: {
                fontColor: '#000',
                usePointStyle: true,
                boxWidth: 35,
                fontSize: 60,
                padding: 25,
            },
        },
    };

    constructor() {
        super();
    }

    public mounted() {
        this.createChart({
            datasets: [
                {
                    data: this.data,
                    backgroundColor: this.colors,
                },
            ],
            labels: this.labels,
        });
    }

    public createChart(chartData: object) {
        const canvas = document.querySelector(`#grouping-${this.id}`) as HTMLCanvasElement;
        const options = {
            type: 'doughnut',
            data: chartData,
            options: this.options,
            borderColor: 'none',
        };
        return new Chart(canvas, options);
        
    }
}
